module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAATElEQVQ4y83U2QkAIAwD0IADOJKrdyQHEGIFrw2S/L2/0gv80iFW4KRZiFFJF604qI5sEAcslFXFnZhWKNzl6bUWB3d7tJJf8ZPPr5t5wtm74PAkWgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNjo0MyswOTowMHkN2/UAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjYrMDk6MDDL5wzeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00426_100x100.png
// module id = xPOt
// module chunks = 0